<script>
import { required, email } from "vuelidate/lib/validators";
import DatePicker from "vue2-datepicker";

// Custom Components
import superService from "@/helpers/APIService/super.service";
import Middleware from "@/helpers/middlewares";
import errorHandler from "@/helpers/errorHandler";
import Multiselect from "vue-multiselect";
import { gender_type } from "@/helpers/global.variable";
import handleLogic from "@/helpers/handleLogic";

export default {
  data() {
    return {
      user_form: {
        first_name: "",
        last_name: "",
        gender: "",
        date_of_birth: null,
        address_line_first: null,
        address_line_second: null,
        zip_code: null,
        city: null,
        state: null,
        country: null,
        mobile: "",
        mobile_iso: "US",
        password: "",
        user_hotel: "",
        hotel: [],
        is_active: true,
        domain_enable: true,
        message_app_setting: {
          currant_status: "offline",
          is_access_message_app: true,
          is_edit_booking_guest: true,
          is_view_booking_guest: true,
          is_edit_service_request: true,
          is_view_service_request: true,
          is_edit_group_tag_setting: true,
          is_edit_guest_inbox_group: true,
          is_edit_lobby_inbox_group: true,
          is_view_guest_inbox_group: true,
          is_view_lobby_inbox_group: true,
          is_edit_maintenance_request: true,
          is_sent_guest_inbox_message: true,
          is_sent_lobby_inbox_message: true,
          is_view_maintenance_request: true,
        },
        iot_app_setting: {
          is_set_admin_key: true,
          is_set_guest_key: true,
          is_set_staff_key: true,
          is_access_web_app: true,
          is_deadbolt_unlock: true,
          is_set_common_door: true,
          is_set_keycode_key: true,
          is_access_desktop_app: true,
        },
      },
      submitted: false,
      isBtnLoading: false,
      iserror: false,
      user_hotel_options: [],
      gender_options: gender_type,
      isPhoneNoValid: true,
      mobileNoToBeSave: null,
    };
  },
  components: {
    Multiselect,
    DatePicker,
  },
  props: {
    userDetails: Object,
    isEdit: Boolean,
  },
  emits: ["submitted", "cancelSubmit"],
  validations: {
    user_form: {
      first_name: { required },
      last_name: { required },
      password: { required },
      user_hotel: { required },
      email: { required, email },
    },
  },
  mounted() {
    this.getHotels();
  },
  methods: {
    // Method is used to get hotel list
    async getHotels() {
      try {
        if (localStorage.getItem("hotels")) {
          this.user_hotel_options = JSON.parse(
            atob(localStorage.getItem("hotels"))
          );
        } else {
          const response = await superService.getHotelsList();
          if (response) {
            response.forEach((element) => {
              this.user_hotel_options.push({
                value: element.id,
                text: element.name,
              });
            });
          }
        }
        this.setValue();
      } catch (error) {
        errorHandler(error);
      }
    },
    // Method is used to set data on edit time
    setValue() {
      if (this.isEdit) {
        Object.keys(this.userDetails).map((key) => {
          if (
            this.userDetails[key] !== null ||
            this.userDetails[key] !== undefined
          ) {
            this.user_form[key] = this.userDetails[key];
            if (key == "user_hotel") {
              this.user_form[key] = this.userDetails[key];
            }
            if (key == "password") {
              this.user_form[key] = "********";
            }
          }
        });
        this.user_form.user_hotel = {
          text: this.userDetails.user_hotel.name,
          value: this.userDetails.user_hotel.id,
        };
        const hotelarr = this.userDetails.hotel;
        const arr = [];
        this.user_hotel_options.forEach((element) => {
          if (hotelarr.includes(element.value)) {
            arr.push({
              value: element.value,
              text: element.text,
            });
          }
        });
        this.user_form.hotel = arr;
      } else {
        this.generatePassword();
      }
    },
    // User Form Submit
    onSubmit() {
      this.submitted = true;
      this.isBtnLoading = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.isBtnLoading = false;
        return;
      } else {
        if (!this.isPhoneNoValid) {
          this.isBtnLoading = false;
          return;
        }
        this.user_form.hotel = this.user_form.hotel.map((val) => val.value);
        this.user_form.user_hotel = this.user_form.user_hotel.value;
        this.user_form.mobile = this.mobileNoToBeSave;
        if (this.isEdit) {
          // Edit User
          if (this.user_form.password == "********") {
            delete this.user_form.password;
          }
          delete this.user_form.profile_picture;
          superService
            .editHotelUser(this.user_form.id, this.user_form)
            .then(() => {
              Middleware.notification("Successfully updated !!", "success");
              this.isBtnLoading = false;
              this.$emit("submitted", this.userDetails);
            })
            .catch((error) => {
              errorHandler(error);
              this.isBtnLoading = false;
            });
        } else {
          // Add User
          delete this.user_form.gender;
          superService
            .addHotelUser(this.user_form)
            .then(() => {
              Middleware.notification("Successfully added !!", "success");
              this.isBtnLoading = false;
              this.$emit("submitted", this.userDetails);
            })
            .catch((error) => {
              errorHandler(error);
              this.isBtnLoading = false;
            });
        }
      }
    },
    // Method is use for cancel to add new building
    cancelSubmit() {
      this.$emit("cancelSubmit");
    },
    handleValidation(number) {
      if (number) {
        const data = handleLogic.phoneNumberHandle(number);
        if (data) {
          this.user_form.mobile_iso = data.number_iso;
          this.isPhoneNoValid = data.valid;
          this.mobileNoToBeSave = data.number;
        }
      }
    },
    // Method Generate Password
    generatePassword() {
      let length = 12,
        charset =
          "abcdefghijklmnopqrstuvwxyz0123456789ABCDEFGHIJKLMNOPQSTUVWXYZ",
        retVal = "";
      for (var i = 0, n = charset.length; i < length; ++i) {
        retVal += charset.charAt(Math.floor(Math.random() * n));
      }
      this.user_form.password = retVal;
    },
  },
};
</script>

<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <h4>{{ this.isEdit ? "Update" : "Add New" }} User Details</h4>
        <hr />
      </div>
      <b-form @submit.prevent="onSubmit">
        <div class="row">
          <!-- Basic Details -->
          <h4 class="card-title">Basic Details</h4>
          <hr />

          <div class="col-md-4 col-sm-6">
            <b-form-group class="mb-3" label-for="first_name">
              <span slot="label">
                First Name<span class="text-danger">*</span></span
              >
              <b-form-input
                id="first_name"
                type="text"
                autocomplete="off"
                v-model="user_form.first_name"
                :class="{
                  'is-invalid': submitted && $v.user_form.first_name.$error,
                }"
              ></b-form-input>
              <div
                v-if="submitted && $v.user_form.first_name.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.user_form.first_name.required"
                  >First Name is required.</span
                >
              </div>
            </b-form-group>
          </div>
          <div class="col-md-4 col-sm-6">
            <b-form-group class="mb-3" label-for="last_name">
              <span slot="label">
                Last Name<span class="text-danger">*</span></span
              >
              <b-form-input
                id="last_name"
                type="text"
                autocomplete="off"
                v-model="user_form.last_name"
                :class="{
                  'is-invalid': submitted && $v.user_form.last_name.$error,
                }"
              ></b-form-input>
              <div
                v-if="submitted && $v.user_form.last_name.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.user_form.last_name.required"
                  >Last Name is required.</span
                >
              </div>
            </b-form-group>
          </div>
          <div class="col-md-4 col-sm-6">
            <b-form-group class="mb-3" label-for="password">
              <span slot="label">
                Password<span class="text-danger">*</span></span
              >
              <b-form-input
                id="password"
                type="text"
                autocomplete="off"
                v-model="user_form.password"
                :class="{
                  'is-invalid': submitted && $v.user_form.password.$error,
                }"
              >
                <template #prefix>
                  <LockOutlined class="site-form-item-icon" />
                </template>
              </b-form-input>
              <div
                v-if="submitted && $v.user_form.password.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.user_form.password.required"
                  >Password is required.</span
                >
              </div>
            </b-form-group>
          </div>
          <div class="col-md-4 col-sm-6" v-if="isEdit">
            <b-form-group class="mb-3" label-for="gender">
              <span slot="label"> gender </span>
              <b-form-select
                class="form-select"
                id="gender"
                type="text"
                autocomplete="off"
                v-model="user_form.gender"
                :options="gender_options"
              >
              </b-form-select>
            </b-form-group>
          </div>
          <div class="col-md-4 col-sm-6" v-if="isEdit">
            <b-form-group class="mb-3" label-for="date_of_birth">
              <span slot="label"> Date Of Birth</span>
              <date-picker
                lang="en"
                placeholder="Select date to stay"
                v-model="user_form.date_of_birth"
                type="date"
                value-type="format"
                :clearable="false"
              ></date-picker>
            </b-form-group>
          </div>
          <div class="col-md-4 col-sm-6">
            <b-form-group class="mb-3" label-for="user_hotel">
              <span slot="label">
                User Hotel <span class="text-danger">*</span>
              </span>
              <multiselect
                v-model="user_form.user_hotel"
                :options="user_hotel_options"
                :show-labels="false"
                placeholder="Search Hotel"
                label="text"
                track-by="value"
                id="user_hotel"
                :class="{
                  'is-invalid': submitted && $v.user_form.user_hotel.$error,
                }"
              ></multiselect>

              <div
                v-if="submitted && $v.user_form.user_hotel.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.user_form.user_hotel.required"
                  >User Hotel is required.</span
                >
              </div>
            </b-form-group>
          </div>
          <div class="col-md-8 col-sm-12">
            <div class="mb-3">
              <label for="is_active">Hotel </label>
              <multiselect
                v-model="user_form.hotel"
                track-by="value"
                label="text"
                placeholder="Select multi hotel"
                :options="user_hotel_options"
                :multiple="true"
                :taggable="true"
                :allow-empty="false"
              >
              </multiselect>
            </div>
          </div>

          <!-- Contact Details -->
          <h4 class="card-title">Contact Details</h4>
          <hr />

          <div class="col-md-4 col-sm-6">
            <b-form-group class="mb-3" label-for="email">
              <span slot="label">
                Email <span class="text-danger">*</span></span
              >
              <b-form-input
                id="email"
                type="text"
                autocomplete="off"
                placeholder="Type Email Address"
                v-model="user_form.email"
                :class="{
                  'is-invalid': submitted && $v.user_form.email.$error,
                }"
              ></b-form-input>
              <div
                v-if="submitted && $v.user_form.email.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.user_form.email.required"
                  >Email is required.</span
                >
                <span v-if="!$v.user_form.email.email">Enter valid email.</span>
              </div>
            </b-form-group>
          </div>
          <div class="col-md-4 col-sm-6">
            <b-form-group class="mb-3" label-for="mobile">
              <span slot="label">
                mobile<span class="text-danger">*</span>
              </span>
              <vue-tel-input
                class="text-dark-gray"
                v-model="user_form.mobile"
                :validCharactersOnly="true"
                :maxLen="11"
                :defaultCountry="
                  user_form
                    ? user_form.mobile_iso !== null
                      ? user_form.mobile_iso
                      : 'US'
                    : 'US'
                "
                @validate="handleValidation"
              >
              </vue-tel-input>
              <div
                class="invalid-feedback d-block"
                :class="
                  mobileNoToBeSave !== '' && !isPhoneNoValid
                    ? 'd-block'
                    : 'd-none'
                "
              >
                <span>Enter valid mobile number.</span>
              </div>
            </b-form-group>
          </div>

          <!-- Address Details -->
          <h4 class="card-title">Address Details</h4>
          <hr />

          <div class="col-md-4 col-sm-6">
            <b-form-group class="mb-3" label-for="address_line_first">
              <span slot="label"> First Address line </span>
              <b-form-input
                id="address_line_first"
                type="text"
                autocomplete="off"
                v-model="user_form.address_line_first"
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-4 col-sm-6">
            <b-form-group class="mb-3" label-for="address_line_second">
              <span slot="label"> Second Address line</span>
              <b-form-input
                id="address_line_second"
                type="text"
                autocomplete="off"
                v-model="user_form.address_line_second"
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-4 col-sm-6">
            <b-form-group class="mb-3" label-for="zip_code">
              <span slot="label"> Zip Code</span>
              <b-form-input
                id="zip_code"
                type="text"
                autocomplete="off"
                v-model="user_form.zip_code"
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-4 col-sm-6">
            <b-form-group class="mb-3" label-for="city">
              <span slot="label"> City</span>
              <b-form-input
                id="city"
                type="text"
                autocomplete="off"
                v-model="user_form.city"
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-4 col-sm-6">
            <b-form-group class="mb-3" label-for="state">
              <span slot="label"> State</span>
              <b-form-input
                id="state"
                type="text"
                autocomplete="off"
                v-model="user_form.state"
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-4 col-sm-6">
            <b-form-group class="mb-3" label-for="country">
              <span slot="label"> Country</span>
              <b-form-input
                id="country"
                type="text"
                autocomplete="off"
                v-model="user_form.country"
              ></b-form-input>
            </b-form-group>
          </div>

          <!-- Message Setting Details -->
          <template v-if="isEdit">
            <h4 class="card-title">Message Setting Details</h4>
            <hr />

            <div class="col-md-2">
              <div class="mb-3">
                <label for="currant_status">Currant Status</label>
                <div class="form-check form-switch my-1" slot="currant_status">
                  <input
                    class="form-check-input"
                    id="currant_status"
                    type="checkbox"
                    v-model="user_form.message_app_setting.currant_status"
                  />
                </div>
              </div>
            </div>
            <div class="col-md-2">
              <div class="mb-3">
                <label for="is_access_message_app">message app</label>
                <div
                  class="form-check form-switch my-1"
                  slot="is_access_message_app"
                >
                  <input
                    class="form-check-input"
                    id="is_access_message_app"
                    type="checkbox"
                    v-model="
                      user_form.message_app_setting.is_access_message_app
                    "
                  />
                </div>
              </div>
            </div>
            <div class="col-md-2">
              <div class="mb-3">
                <label for="is_edit_booking_guest">edit booking guest</label>
                <div
                  class="form-check form-switch my-1"
                  slot="is_edit_booking_guest"
                >
                  <input
                    class="form-check-input"
                    id="is_edit_booking_guest"
                    type="checkbox"
                    v-model="
                      user_form.message_app_setting.is_edit_booking_guest
                    "
                  />
                </div>
              </div>
            </div>
            <div class="col-md-2">
              <div class="mb-3">
                <label for="is_view_booking_guest">view booking guest</label>
                <div
                  class="form-check form-switch my-1"
                  slot="is_view_booking_guest"
                >
                  <input
                    class="form-check-input"
                    id="is_view_booking_guest"
                    type="checkbox"
                    v-model="
                      user_form.message_app_setting.is_view_booking_guest
                    "
                  />
                </div>
              </div>
            </div>
            <div class="col-md-2">
              <div class="mb-3">
                <label for="is_edit_service_request"
                  >edit service request</label
                >
                <div
                  class="form-check form-switch my-1"
                  slot="is_edit_service_request"
                >
                  <input
                    class="form-check-input"
                    id="is_edit_service_request"
                    type="checkbox"
                    v-model="
                      user_form.message_app_setting.is_edit_service_request
                    "
                  />
                </div>
              </div>
            </div>
            <div class="col-md-2">
              <div class="mb-3">
                <label for="is_view_service_request"
                  >view service request</label
                >
                <div
                  class="form-check form-switch my-1"
                  slot="is_view_service_request"
                >
                  <input
                    class="form-check-input"
                    id="is_view_service_request"
                    type="checkbox"
                    v-model="
                      user_form.message_app_setting.is_view_service_request
                    "
                  />
                </div>
              </div>
            </div>
            <div class="col-md-2">
              <div class="mb-3">
                <label for="is_edit_group_tag_setting"
                  >edit group tag setting</label
                >
                <div
                  class="form-check form-switch my-1"
                  slot="is_edit_group_tag_setting"
                >
                  <input
                    class="form-check-input"
                    id="is_edit_group_tag_setting"
                    type="checkbox"
                    v-model="
                      user_form.message_app_setting.is_edit_group_tag_setting
                    "
                  />
                </div>
              </div>
            </div>
            <div class="col-md-2">
              <div class="mb-3">
                <label for="is_edit_guest_inbox_group"
                  >edit guest inbox group</label
                >
                <div
                  class="form-check form-switch my-1"
                  slot="is_edit_guest_inbox_group"
                >
                  <input
                    class="form-check-input"
                    id="is_edit_guest_inbox_group"
                    type="checkbox"
                    v-model="
                      user_form.message_app_setting.is_edit_guest_inbox_group
                    "
                  />
                </div>
              </div>
            </div>
            <div class="col-md-2">
              <div class="mb-3">
                <label for="is_edit_lobby_inbox_group"
                  >edit lobby inbox group</label
                >
                <div
                  class="form-check form-switch my-1"
                  slot="is_edit_lobby_inbox_group"
                >
                  <input
                    class="form-check-input"
                    id="is_edit_lobby_inbox_group"
                    type="checkbox"
                    v-model="
                      user_form.message_app_setting.is_edit_lobby_inbox_group
                    "
                  />
                </div>
              </div>
            </div>
            <div class="col-md-2">
              <div class="mb-3">
                <label for="is_view_guest_inbox_group"
                  >view guest inbox group</label
                >
                <div
                  class="form-check form-switch my-1"
                  slot="is_view_guest_inbox_group"
                >
                  <input
                    class="form-check-input"
                    id="is_view_guest_inbox_group"
                    type="checkbox"
                    v-model="
                      user_form.message_app_setting.is_view_guest_inbox_group
                    "
                  />
                </div>
              </div>
            </div>
            <div class="col-md-2">
              <div class="mb-3">
                <label for="is_view_lobby_inbox_group"
                  >view lobby inbox group</label
                >
                <div
                  class="form-check form-switch my-1"
                  slot="is_view_lobby_inbox_group"
                >
                  <input
                    class="form-check-input"
                    id="is_view_lobby_inbox_group"
                    type="checkbox"
                    v-model="
                      user_form.message_app_setting.is_view_lobby_inbox_group
                    "
                  />
                </div>
              </div>
            </div>
            <div class="col-md-2">
              <div class="mb-3">
                <label for="is_edit_maintenance_request"
                  >edit maintenance request</label
                >
                <div
                  class="form-check form-switch my-1"
                  slot="is_edit_maintenance_request"
                >
                  <input
                    class="form-check-input"
                    id="is_edit_maintenance_request"
                    type="checkbox"
                    v-model="
                      user_form.message_app_setting.is_edit_maintenance_request
                    "
                  />
                </div>
              </div>
            </div>
            <div class="col-md-2">
              <div class="mb-3">
                <label for="is_sent_guest_inbox_message"
                  >sent guest inbox message</label
                >
                <div
                  class="form-check form-switch my-1"
                  slot="is_sent_guest_inbox_message"
                >
                  <input
                    class="form-check-input"
                    id="is_sent_guest_inbox_message"
                    type="checkbox"
                    v-model="
                      user_form.message_app_setting.is_sent_guest_inbox_message
                    "
                  />
                </div>
              </div>
            </div>
            <div class="col-md-2">
              <div class="mb-3">
                <label for="is_sent_lobby_inbox_message"
                  >sent lobby inbox message</label
                >
                <div
                  class="form-check form-switch my-1"
                  slot="is_sent_lobby_inbox_message"
                >
                  <input
                    class="form-check-input"
                    id="is_sent_lobby_inbox_message"
                    type="checkbox"
                    v-model="
                      user_form.message_app_setting.is_sent_lobby_inbox_message
                    "
                  />
                </div>
              </div>
            </div>
            <div class="col-md-2">
              <div class="mb-3">
                <label for="is_view_maintenance_request"
                  >view maintenance request</label
                >
                <div
                  class="form-check form-switch my-1"
                  slot="is_view_maintenance_request"
                >
                  <input
                    class="form-check-input"
                    id="is_view_maintenance_request"
                    type="checkbox"
                    v-model="
                      user_form.message_app_setting.is_view_maintenance_request
                    "
                  />
                </div>
              </div>
            </div>

            <!-- Iot App Setting Details -->
            <h4 class="card-title">Iot App Setting Details</h4>
            <hr />

            <div class="col-md-2">
              <div class="mb-3">
                <label for="is_set_admin_key">set admin key</label>
                <div
                  class="form-check form-switch my-1"
                  slot="is_set_admin_key"
                >
                  <input
                    class="form-check-input"
                    id="is_set_admin_key"
                    type="checkbox"
                    v-model="user_form.iot_app_setting.is_set_admin_key"
                  />
                </div>
              </div>
            </div>
            <div class="col-md-2">
              <div class="mb-3">
                <label for="is_set_guest_key">set admin key</label>
                <div
                  class="form-check form-switch my-1"
                  slot="is_set_guest_key"
                >
                  <input
                    class="form-check-input"
                    id="is_set_guest_key"
                    type="checkbox"
                    v-model="user_form.iot_app_setting.is_set_guest_key"
                  />
                </div>
              </div>
            </div>
            <div class="col-md-2">
              <div class="mb-3">
                <label for="is_set_staff_key">set staff key</label>
                <div
                  class="form-check form-switch my-1"
                  slot="is_set_staff_key"
                >
                  <input
                    class="form-check-input"
                    id="is_set_staff_key"
                    type="checkbox"
                    v-model="user_form.iot_app_setting.is_set_staff_key"
                  />
                </div>
              </div>
            </div>
            <div class="col-md-2">
              <div class="mb-3">
                <label for="is_access_web_app">is access web app</label>
                <div
                  class="form-check form-switch my-1"
                  slot="is_access_web_app"
                >
                  <input
                    class="form-check-input"
                    id="is_access_web_app"
                    type="checkbox"
                    v-model="user_form.iot_app_setting.is_access_web_app"
                  />
                </div>
              </div>
            </div>
            <div class="col-md-2">
              <div class="mb-3">
                <label for="is_deadbolt_unlock">deadbolt unlock</label>
                <div
                  class="form-check form-switch my-1"
                  slot="is_deadbolt_unlock"
                >
                  <input
                    class="form-check-input"
                    id="is_deadbolt_unlock"
                    type="checkbox"
                    v-model="user_form.iot_app_setting.is_deadbolt_unlock"
                  />
                </div>
              </div>
            </div>
            <div class="col-md-2">
              <div class="mb-3">
                <label for="is_set_common_door">set common door</label>
                <div
                  class="form-check form-switch my-1"
                  slot="is_set_common_door"
                >
                  <input
                    class="form-check-input"
                    id="is_set_common_door"
                    type="checkbox"
                    v-model="user_form.iot_app_setting.is_set_common_door"
                  />
                </div>
              </div>
            </div>
            <div class="col-md-2">
              <div class="mb-3">
                <label for="is_set_keycode_key">set keycode key</label>
                <div
                  class="form-check form-switch my-1"
                  slot="is_set_keycode_key"
                >
                  <input
                    class="form-check-input"
                    id="is_set_keycode_key"
                    type="checkbox"
                    v-model="user_form.iot_app_setting.is_set_keycode_key"
                  />
                </div>
              </div>
            </div>
            <div class="col-md-2">
              <div class="mb-3">
                <label for="is_access_desktop_app">access desktop app</label>
                <div
                  class="form-check form-switch my-1"
                  slot="is_access_desktop_app"
                >
                  <input
                    class="form-check-input"
                    id="is_access_desktop_app"
                    type="checkbox"
                    v-model="user_form.iot_app_setting.is_access_desktop_app"
                  />
                </div>
              </div>
            </div>
          </template>
          <div class="col-md-12">
            <b-button
              class="float-end ms-2"
              variant="outline-primary"
              type="reset"
              @click="cancelSubmit"
              >Cancel</b-button
            >
            <b-button
              class="float-end"
              variant="outline-primary"
              type="submit"
              :class="{
                disabled: isBtnLoading,
              }"
            >
              <i
                class="bx bx-loader bx-spin font-size-16 align-middle me-2"
                v-if="isBtnLoading"
              ></i>
              {{ this.isEdit ? "Update" : "Save" }}
            </b-button>
          </div>
        </div>
      </b-form>
    </div>
  </div>
</template>
